import React from 'react';
import PropTypes from 'prop-types';
import SvgImg from '../../components/Svg/SvgImg';

/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */

const Linkedin = ({ width, height }) => (
  <SvgImg
    viewbox="0 0 512 512"
    title="icons / followus / linkedin"
    width={width}
    height={height}
  >
    <g>
      <circle cx="256" cy="256" fill="#0077B5" r="256" />
      <path d="M186.8,371.7h-51.9V204.1h51.9V371.7z M160.6,182.2   c-16.9,0-30.7-13.8-30.7-30.9c0-17.1,13.7-30.9,30.7-30.9c16.9,0,30.7,13.8,30.7,30.9C191.3,168.3,177.5,182.2,160.6,182.2z    M381.2,371.7h-51.6c0,0,0-63.8,0-88c0-24.1-9.2-37.6-28.2-37.6c-20.8,0-31.6,14-31.6,37.6c0,25.8,0,88,0,88h-49.8V204.1h49.8v22.6   c0,0,15-27.7,50.5-27.7c35.5,0,61,21.7,61,66.6C381.2,310.5,381.2,371.7,381.2,371.7z" fill="#FFFFFF" id="linkedin-square-rounded-icon_1_" />
    </g>
  </SvgImg>
);
Linkedin.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};
Linkedin.defaultProps = {
  width: undefined,
  height: undefined,
};
export default Linkedin;
